import { render, staticRenderFns } from "./onArrq.vue?vue&type=template&id=7b9fd94a"
import script from "./onArrq.vue?vue&type=script&lang=js"
export * from "./onArrq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports